import { Add, Addchart, AddCircleOutline, AddHome, Clear, NewReleases, Search } from "@mui/icons-material";
import {
	Box,
	Button,
	FormControl,
	Grid,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	SelectChangeEvent,
	TextField,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { useState } from "react";

interface PeopleToolbarProps {
	textSearch?: string;
	onChangeTextSearch?: (value: string) => void;
	onClearTextSearch?: () => void;
	showInputSearch?: boolean;
	showStatusSelect?: boolean;
	onChangeStatus?: (value: string) => void;
	showRefreshButton?: boolean;
	onClickRefresh?: () => void;
	showCreateButton?: boolean;
	onClickCreate?: () => void;
}

export function PeopleToolbar({
	textSearch = "",
	onChangeTextSearch,
	onClearTextSearch,
	showInputSearch = true,
	showStatusSelect = false,
	onChangeStatus,
	showRefreshButton = true,
	onClickRefresh,
	showCreateButton = true,
	onClickCreate,
}: PeopleToolbarProps) {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const [status, setStatus] = useState("Todos");

	const handleStatusChange = (e: SelectChangeEvent) => {
		const value = e.target.value;
		setStatus(value);
		onChangeStatus?.(value);
	};

	return (
		<Box component={Paper} display="flex" flexDirection="column" padding={2} gap={1} mx={1}>
			<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
				<Grid container spacing={2} direction={isSmallScreen ? "column" : "row"} alignItems="center">
					{showStatusSelect && (
						<Grid item xs={12} sm={6} md={2}>
							<FormControl fullWidth size="small">
								<InputLabel id="status-label">Status</InputLabel>
								<Select labelId="status-label" value={status} label="Status" onChange={handleStatusChange}>
									<MenuItem value="Todos">Todos</MenuItem>
									<MenuItem value="active">Ativos</MenuItem>
									<MenuItem value="inactive">Inativos</MenuItem>
								</Select>
							</FormControl>
						</Grid>
					)}

					{showInputSearch && (
						<Grid item xs={12} sm={6} md={3}>
							<TextField
								fullWidth
								size="small"
								placeholder="Pesquisar..."
								value={textSearch}
								onChange={(e) => onChangeTextSearch?.(e.target.value)}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<Search />
										</InputAdornment>
									),
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												onClick={() => {
													onClearTextSearch?.();
													onChangeTextSearch?.("");
												}}
											>
												<Clear />
											</IconButton>
										</InputAdornment>
									),
								}}
							/>
						</Grid>
					)}
					<Grid item xs={12} sm={12} md>
						<Box display="flex" justifyContent="space-between" gap={1}>
							{showRefreshButton && (
								<Button variant="contained" onClick={onClickRefresh}>
									Pesquisar
								</Button>
							)}
						</Box>
					</Grid>
				</Grid>
				{showCreateButton && (
					<Button variant="contained" color="primary" onClick={onClickCreate} sx={{ mt: 2, width: isSmallScreen ? "100%" : "auto", minWidth: 180 }}>
						<Addchart sx={{ mr: 1 }} />
						Novo Item
					</Button>
				)}
			</Box>
		</Box>
	);
}
